import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { debounce } from 'lodash';
import { Customer } from '@newmoon-org/types';

import CustomerService from '@/service/customer.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerAutocomplete',
  props: ['initialSearch'],
  setup(__props) {

const props = __props



const customerSearch = ref<string>(props.initialSearch);
const customers = ref<Customer[]>([]);
const isCustomerLoading = ref<boolean>(false);

const customerFetcher = debounce(async function (search) {
  if (!search.length) {
    customers.value = await CustomerService.list({ search: '', page: 0, pageSize: 40, searchFilter: undefined }).then(
      ({ data }) => data
    );
    return;
  }
  isCustomerLoading.value = true;
  return CustomerService.list({ search, page: 0, pageSize: 40, searchFilter: undefined })
    .then(({ data }) => (customers.value = [...data]))
    .catch(e => {
      customers.value = [];
      console.error(e.message);
    })
    .finally(() => (isCustomerLoading.value = false));
}, 500);

async function clearInvalidCustomer() {
  customerSearch.value = '';
}

return { __sfc: true,props, customerSearch, customers, isCustomerLoading, customerFetcher, clearInvalidCustomer }
}

})